import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon, SlidersIcon, MapPinIcon, BedIcon, BathIcon, CheckCircleIcon, XIcon } from 'lucide-react';
import PropertyCard from '../components/Properties/PropertyCard';
import FilterSidebar from '../components/Properties/FilterSidebar';
// Mock data
const properties = [{
  id: 1,
  title: 'Luxury 3 Bedroom Apartment',
  location: 'Lekki Phase 1, Lagos',
  price: '₦75,000,000',
  bedrooms: 3,
  bathrooms: 3,
  area: '180 sqm',
  image: 'https://images.unsplash.com/photo-1613545325278-f24b0cae1224?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
  verified: true,
  featured: true
}, {
  id: 2,
  title: 'Modern 4 Bedroom Duplex',
  location: 'Maitama, Abuja',
  price: '₦120,000,000',
  bedrooms: 4,
  bathrooms: 4,
  area: '350 sqm',
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
  verified: true,
  featured: false
}, {
  id: 3,
  title: 'Waterfront 5 Bedroom Villa',
  location: 'Banana Island, Lagos',
  price: '₦350,000,000',
  bedrooms: 5,
  bathrooms: 6,
  area: '500 sqm',
  image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
  verified: true,
  featured: true
}, {
  id: 4,
  title: '2 Bedroom Apartment with Pool',
  location: 'Victoria Island, Lagos',
  price: '₦65,000,000',
  bedrooms: 2,
  bathrooms: 2,
  area: '120 sqm',
  image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
  verified: true,
  featured: false
}, {
  id: 5,
  title: '3 Bedroom Terrace House',
  location: 'Ikeja GRA, Lagos',
  price: '₦85,000,000',
  bedrooms: 3,
  bathrooms: 3,
  area: '220 sqm',
  image: 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
  verified: true,
  featured: false
}, {
  id: 6,
  title: 'Premium 4 Bedroom Penthouse',
  location: 'Ikoyi, Lagos',
  price: '₦180,000,000',
  bedrooms: 4,
  bathrooms: 5,
  area: '400 sqm',
  image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
  verified: true,
  featured: true
}];
const PropertyListings = () => {
  const [showFilters, setShowFilters] = useState(false);
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-1720">
      {/* Search Bar */}
      <div className="bg-white shadow-sm" data-id="element-1721">
        <div className="container mx-auto px-4 py-4" data-id="element-1722">
          <div className="flex flex-col md:flex-row md:items-center space-y-4 md:space-y-0 md:space-x-4" data-id="element-1723">
            <div className="flex-grow relative" data-id="element-1724">
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} data-id="element-1725" />
              <input type="text" placeholder="Search for properties by location, type, etc." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1726" />
            </div>
            <button className="flex items-center justify-center px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 md:w-auto" onClick={() => setShowFilters(!showFilters)} data-id="element-1727">
              <SlidersIcon size={20} className="mr-2" data-id="element-1728" />
              Filters
            </button>
            <Link to="/properties" className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition flex items-center justify-center" data-id="element-1729">
              <SearchIcon size={20} className="mr-2" data-id="element-1730" />
              Search
            </Link>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 py-8" data-id="element-1731">
        <div className="flex flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-6" data-id="element-1732">
          {/* Filters Sidebar - Mobile */}
          {showFilters && <div className="fixed inset-0 bg-gray-800 bg-opacity-75 z-50 md:hidden" data-id="element-1733">
              <div className="h-full w-full max-w-xs bg-white p-4 overflow-y-auto" data-id="element-1734">
                <div className="flex justify-between items-center mb-6" data-id="element-1735">
                  <h2 className="text-xl font-bold" data-id="element-1736">Filters</h2>
                  <button onClick={() => setShowFilters(false)} className="p-1" data-id="element-1737">
                    <XIcon size={24} data-id="element-1738" />
                  </button>
                </div>
                <FilterSidebar data-id="element-1739" />
                <div className="mt-6" data-id="element-1740">
                  <button className="w-full bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition" onClick={() => setShowFilters(false)} data-id="element-1741">
                    Apply Filters
                  </button>
                </div>
              </div>
            </div>}
          {/* Filters Sidebar - Desktop */}
          <div className="hidden md:block md:w-1/4 lg:w-1/5" data-id="element-1742">
            <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1743">
              <h2 className="text-xl font-bold mb-6" data-id="element-1744">Filters</h2>
              <FilterSidebar data-id="element-1745" />
            </div>
          </div>
          {/* Property Listings */}
          <div className="md:w-3/4 lg:w-4/5" data-id="element-1746">
            <div className="flex justify-between items-center mb-6" data-id="element-1747">
              <h1 className="text-2xl font-bold" data-id="element-1748">Properties in Nigeria</h1>
              <div className="text-gray-600" data-id="element-1749">
                Showing {properties.length} properties
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1750">
              {properties.map(property => <PropertyCard key={property.id} property={property} data-id="element-1751" />)}
            </div>
            <div className="mt-8 flex justify-center" data-id="element-1752">
              <div className="flex space-x-2" data-id="element-1753">
                {[1, 2, 3, 4, 5].map(page => <button key={page} className={`w-10 h-10 flex items-center justify-center rounded-lg ${page === 1 ? 'bg-green-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-100'}`} data-id="element-1754">
                    {page}
                  </button>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default PropertyListings;